// client/src/components/Dashboard.js
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Dashboard.css";

function Dashboard() {
  const navigate = useNavigate();

  useEffect(() => {
    const checkSession = () => {
      const isLoggedIn = sessionStorage.getItem("isLoggedIn") === "true";
      if (!isLoggedIn) {
        navigate("/login", { replace: true }); // redirect if session expired
      }
    };

    // 🔹 Check immediately on mount
    checkSession();

    // 🔹 Handle Back/Forward restores (bfcache)
    window.addEventListener("pageshow", checkSession);

    return () => {
      window.removeEventListener("pageshow", checkSession);
    };
  }, [navigate]);

  const handleLogout = () => {
    sessionStorage.removeItem("isLoggedIn"); // clear session
    navigate("/login", { replace: true }); // redirect to login & prevent going forward to dashboard
  };

  return (
    <div className="dashboard-page">
      {/* Logout button on top-right */}
      <button className="logout-btn" onClick={handleLogout}>
        Logout
      </button>

      <header className="dashboard-header">
        <h1>MFA Dashboard 🚀</h1>
      </header>

      <main className="dashboard-content">
        <div className="card">
          <h2>Welcome 👋</h2>
          <p>You have successfully logged in using MFA.</p>
        </div>

        <div className="card">
          <h2>User Stats</h2>
          <p>Some details about your login sessions or activity can go here.</p>
        </div>
      </main>
    </div>
  );
}

export default Dashboard;
